/* Greco Tile & Flooring: "Make it home" film hero.
   The film moves forward and back with the scroll, frame by frame (like Apple product pages).
   The film is downloaded once in the background so seeking is instant; until it arrives the
   first frame (poster) shows. Markup: sections/greco-film.liquid. */
(function () {
  'use strict';
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  // scroll position (0..1) -> film progress (0..1): short hold at the start and the end
  var HOLD_IN = 0.06, HOLD_OUT = 0.05;
  // caption changes (scroll positions)
  var CAP_AT = [0, 0.12, 0.33, 0.55, 0.8];

  function init(root) {
    if (!root || root.__gfInit) return;
    root.__gfInit = true;

    var video = root.querySelector('video');
    var caps = [].slice.call(root.querySelectorAll('[data-cap]'));
    var dots = [].slice.call(root.querySelectorAll('[data-step]'));
    var bar = root.querySelector('.gc-cine__bar i');
    var hint = root.querySelector('.gc-cine__hint');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var html = document.documentElement;
    if (!video) return;

    var tall = window.innerHeight > window.innerWidth * 1.05;
    var src = (tall && video.dataset.srcMobile) ? video.dataset.srcMobile : video.dataset.src;
    if (tall && video.dataset.srcMobile) video.style.objectPosition = '50% 50%';
    video.pause();

    var ready = false, duration = 0, shown = -1, want = 0;

    function useSource(url) {
      video.src = url;
      video.load();
    }
    video.addEventListener('loadedmetadata', function () { duration = video.duration || 0; ready = duration > 0; tick(true); });

    // Download the whole film first (instant seeking), fall back to streaming.
    if (src) {
      if (window.fetch && window.URL && URL.createObjectURL) {
        fetch(src, { mode: 'cors' }).then(function (r) {
          if (!r.ok) throw new Error('film ' + r.status);
          return r.blob();
        }).then(function (b) { useSource(URL.createObjectURL(b)); })
          .catch(function () { useSource(src); });
      } else useSource(src);
    }

    function progress() {
      var r = root.getBoundingClientRect(), span = r.height - window.innerHeight;
      return span > 0 ? clamp(-r.top / span, 0, 1) : 0;
    }
    function filmAt(p) { return clamp((p - HOLD_IN) / (1 - HOLD_IN - HOLD_OUT), 0, 1); }

    var capIdx = -1;
    function setCaption(p) {
      var i = 0;
      for (var k = 0; k < CAP_AT.length; k++) if (p >= CAP_AT[k]) i = k;
      if (i === capIdx) return;
      capIdx = i;
      caps.forEach(function (c, n) {
        var on = n === i;
        c.style.opacity = on ? 1 : 0;
        c.style.transform = on ? 'none' : 'translateY(10px)';
        c.style.visibility = on ? 'visible' : 'hidden';
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i - 1); d.classList.toggle('is-done', n < i - 1); });
    }

    // Header floats transparently over the film while it is on screen
    function headerState() {
      var r = root.getBoundingClientRect();
      html.classList.toggle('gh-film-top', r.bottom > 90 && r.top < 10);
    }

    var cur = 0, lastP = -1;
    function tick(force) {
      var p = progress();
      if (p !== lastP || force) {
        lastP = p;
        if (bar) bar.style.width = (p * 100).toFixed(2) + '%';
        if (hint) hint.style.opacity = clamp(1 - p * 14, 0, 1);
        setCaption(p);
        headerState();
      }
      want = filmAt(p);
      if (!ready) return;
      // ease toward the scroll position for a silky feel
      cur += (want - cur) * (reduce ? 1 : 0.18);
      if (Math.abs(want - cur) < 0.0005) cur = want;
      var t = cur * (duration - 0.05);
      if (!video.seeking && Math.abs(t - shown) > 0.02) {
        shown = t;
        try { if (video.fastSeek) video.fastSeek(t); else video.currentTime = t; } catch (e) {}
      }
    }
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (!visible) html.classList.remove('gh-film-top'); }).observe(root);
    }
    (function loop() { if (visible) tick(false); requestAnimationFrame(loop); })();
    window.addEventListener('resize', function () { tick(true); });
    tick(true);
  }

  function boot() { [].forEach.call(document.querySelectorAll('.gc-film'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.gc-film'); if (r) init(r); });
})();
